/*
 * useAddPanel3.tsx - Add an Entity
 *
 * Created by Dr. Maximillian Dornseif 2021-09
 * Copyright (c) 2021, 2023 HUDORA GmbH
 *
 * Created by Dr. Maximillian Dornseif 2023-10-06 in huWaWi3 33.1.0
 * Copyright (c) 2023 HUDORA GmbH
 */

import { PrimaryButton } from '@fluentui/react/lib/Button';
import { ICommandBarItemProps } from '@fluentui/react/lib/CommandBar';
import { DocumentNode } from 'graphql';
import React, { ReactElement } from 'react';

import { IEntity } from '../../types';
import { EntityCreate3 } from '../components/ke/EntityCreate3';
import { MuiPanel, usePanelMui } from './usePanel';

/** Panel zum Zufügen von Entities.
 *
 * Dabei wird `createPreset` genutzt, um mit `data` die Vorbelegung auszufüllen.
 * */

interface IuseAddPanelProps {
  createMutation?: DocumentNode;
  createTemplate?: Partial<IEntity>;
  entity?: Partial<IEntity>;
}

export function useAddPanel3(
  options: IuseAddPanelProps
): [ICommandBarItemProps, ReactElement, ReactElement, () => void] {
  const [openPanel, panelProps, isPanelOpen, dismissPanel] = usePanelMui('Neuen Datensatz anlegen');

  if (!options.createMutation) {
    return [null, null, null, null];
  }

  const commandBarItem: ICommandBarItemProps = {
    key: 'add',
    text: 'Datensatz zufügen',
    title: 'Neuen Datensatz anlegen',
    ariaLabel: 'Datensatz zufügen',
    iconProps: { iconName: 'Add' },
    iconOnly: false,
    onClick: openPanel,
  };
  const mutateButton = (
    <PrimaryButton
      text="Datensatz zufügen"
      title="Neuen Datensatz anlegen"
      ariaLabel="Zufügen"
      iconProps={{ iconName: 'Add' }}
      onClick={openPanel}
    />
  );

  const newEntity: Partial<IEntity> = options.createTemplate || {};

  const thePanel = isPanelOpen ? (
    <MuiPanel {...panelProps} onDismiss={dismissPanel}>
      <EntityCreate3
        isOpen={true}
        entity={newEntity}
        schemaName={options.schemaName}
        mutation={options.createMutation}
        createTemplate={options.createTemplate}
      />
    </MuiPanel>
  ) : null;

  return [commandBarItem, thePanel, mutateButton, openPanel];
}
